import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AclService} from '../../../services/acl.service';
import {PermissionArea} from '../../../enums/permission-area.enum';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[aclCheck]'
})
export class AclCheckDirective {

    constructor(
        private tRef: TemplateRef<any>,
        private vcRef: ViewContainerRef,
        protected aclService: AclService,
    ) {
    }

    @Input() set aclCheck(permissionArea: string | PermissionArea) {
        if (permissionArea && Array.isArray(permissionArea)) {
            if (permissionArea.some(permission => this.aclService.checkAcl(permission))){
                this.vcRef.createEmbeddedView(this.tRef);
            }
        } else if (
            !permissionArea
            || (permissionArea && this.aclService.checkAcl(permissionArea))
        ) {
            this.vcRef.createEmbeddedView(this.tRef);
        } else {
            this.vcRef.clear();
        }
    }
}
